module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGUlEQVR4nGPwDYr8TwlmGDVg1IBRA4aLAQDpVPcQHill8QAAAABJRU5ErkJggg=="